import { createAction, props } from '@ngrx/store';

import type { HuntingProductGalleryMedia } from '../../models/hunting-product-gallery-media.interface';
import type { HuntingProductMedia } from '../../models/hunting-product-media.model';
import { prefixed } from '../../utils/factory.utils';

const huntingProductSync = prefixed('[Hunting Product Sync]');

export const HuntingProductSyncActions = {
  syncDiscovery: createAction(huntingProductSync('Sync discovery'), props<{ serial: string; deviceId: string }>()),

  syncDiscoverySucceeded: createAction(
    huntingProductSync('Sync discovery succeeded'),
    props<{ serial: string; deviceId: string; pendingCount: number; pendingIds: Array<string> }>()
  ),
  syncDiscoveryFailed: createAction(huntingProductSync('Sync discovery failed'), props<{ error: string }>()),

  mediaItemSync: createAction(huntingProductSync('Media item sync'), props<{ id: string; contentLength: number }>()),
  mediaItemSyncProgress: createAction(
    huntingProductSync('Media item sync progress'),
    props<{ id: string; bytes: number; contentLength: number; mbPerSecWindow: number }>()
  ),
  mediaItemSyncSucceeded: createAction(huntingProductSync('Media item sync succeeded'), props<{ media: HuntingProductMedia }>()),
  mediaItemSyncFailed: createAction(huntingProductSync('Media item sync failed'), props<{ id: string; error: string }>()),

  syncGallerySucceeded: createAction(huntingProductSync('Sync gallery succeeded'), props<{ syncedCount: number }>()),
  syncGalleryFailed: createAction(huntingProductSync('Sync gallery failed'), props<{ error: string }>()),

  loadMedia: createAction(huntingProductSync('Load media'), props<{ serial: string | undefined }>()),
  loadMediaSucceeded: createAction(huntingProductSync('Load media succeeded'), props<{ serial: string; media: Array<HuntingProductGalleryMedia> }>()),
  loadMediaFailed: createAction(huntingProductSync('Load media failed'), props<{ error: string }>()),

  loadMediaItem: createAction(huntingProductSync('Load media item'), props<{ media: HuntingProductMedia }>()),
  loadMediaItemSucceeded: createAction(huntingProductSync('Load media item succeeded'), props<{ media: HuntingProductGalleryMedia }>()),
  loadMediaItemFailed: createAction(huntingProductSync('Load media item failed'), props<{ id: string; error: string }>()),

  cancelSync: createAction(huntingProductSync('Cancel sync')),

  galleryVideoSelected: createAction(huntingProductSync('Gallery video selected'), props<{ mediaId: string }>()),
  galleryVideoViewerDismissed: createAction(huntingProductSync('Gallery video viewer dismissed')),
  galleryVideoPlaybackFailed: createAction(huntingProductSync('Gallery video playback failed'), props<{ mediaId: string }>()),

  localMediaCleared: createAction(huntingProductSync('Local media cleared')),
};
